import "../../css/pages/blogPost.scss";
import circuitLines from "../modules/circuitLines";
import dataCharts from "../modules/dataCharts";
import setBackground from "../modules/setBackground";
import { shareScroll } from "../modules/shareScroll";
import { slidePDF } from "../modules/slidePDF";

import BasePage from "./base";

class BlogPost extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        super.initRellax();
    }

    onReady() {
        super.onReady();
        circuitLines.init();
        dataCharts.init();
        setBackground.init();
    }

    onLoad() {
        super.onLoad();
        shareScroll(Number(document.querySelector(".jsTrigger").clientHeight - 140));
        slidePDF(window.pdfjsLib);
    }
}

new BlogPost();
